goog.provide('el8.model.AjaxQueue');


/**
 * AjaxQueue is a global queue of "subqueues" where each "subqueue" should correspond to the
 * saving of a specific field/data chunk.  Calls should line up in the same "subqueue" if and only if
 * subsequent calls replace previous calls (i.e. saving of the same data).
 * This is why the definition of "dirty" refers to just the LAST call having failed.
 */
el8.model.AjaxQueue = function() {
    this._queues = {};  // queues of ajax opts
    this._deferreds = {};
    this._isInProgress = {};
    this._isDirty = {};
    this._DEFAULT_NAME = 'default';
};

el8.model.AjaxQueue.prototype.doAjax = function(name, opts) {
    if (typeof(name) !== 'string') {
        opts = name || {};
        name = this._DEFAULT_NAME;
    }
    if (this.isFinalized()) {
        UIM && UIM.logError('AjaxQueue '+name+' is attempting another doAjax after finalized');
        return false;
    }
    // Always need a Deferred object per queue
    if (!this._deferreds[name]) {
        this._deferreds[name] = [];
    }
    var dfd = $.Deferred();
    this._deferreds[name].push(dfd);
    // Always need a queue
    if (!this._queues[name]) {
        this._queues[name] = $({});
    }
    var that = this;
    var doIt = function(next) {
        /**
         * Note: if opts has a 'success' or 'error' key, those will
         *       get run before the done() and fail() below.
         */
        var jqXhr =
            $.el8_ajax(opts)
                .done(function() {
                    delete that._isInProgress[name];
                    if (next) { next(); }
                    dfd.resolve();
                }).fail(function() {
                    delete that._isInProgress[name];
                    if (next) { next(); }
                    dfd.reject();
                });
        that._isInProgress[name] = jqXhr;
    };
    this._queues[name].queue(doIt);
    return dfd.promise();
};

el8.model.AjaxQueue.prototype.doFinalAjax= function(opts, failFn) {
    var that = this;
    that._finalize();
    $.when.apply($, that.getAllDeferreds()).done(
        function() { $.el8_ajax(opts); }
    ).fail(
        function() {
            if (failFn) { failFn(); }
            else { $.el8_ajax(opts); }
        }
    );
};

el8.model.AjaxQueue.prototype.abortQueue = function() {
    /**
     * Kill the whole AjaxQueue. This is mostly useful if we want to delete the whole
     * object and therefore want to halt any deferred saves.
     */
    if (this.isFinalized()) {
        UIM && UIM.logError('Attempting to abort already finalized AjaxQueue');
        return false;
    }
    this._finalize();
    for (var name in this._queues) {
        if (this._queues.hasOwnProperty(name)) {
            this._queues[name].clearQueue();

            if (this._isInProgress[name]) {
                this._isInProgress[name].abort();
                delete this._isInProgress[name];
            }
        }
    }
};

el8.model.AjaxQueue.prototype._finalize = function() {
    this._finalized = true;
};

el8.model.AjaxQueue.prototype._isQueueEmpty = function(name) {
    return !this._queues[name].queue().length ||
        (this._queues[name].queue()[0] === 'inprogress');
};

el8.model.AjaxQueue.prototype.getDeferred = function(name) {
    name = name || this._DEFAULT_NAME;
    var deferreds = this._deferreds[name];
    if (deferreds && deferreds.length) {
        // The last deferred in the queue is the one we are waiting on
        return deferreds[deferreds.length - 1].promise();
    } else {
        return null;
    }
};

el8.model.AjaxQueue.prototype.getAllDeferreds = function() {
    var list = [];
    for (var d in this._deferreds) {
        if (this._deferreds.hasOwnProperty(d)) {
            list.push(this.getDeferred(d));
        }
    }
    return list;
};

el8.model.AjaxQueue.prototype.getQueueState = function(name) {
    /**
     * 3 possible states:
     * - "clean": most recent is a success; no pending requests (or if queue hasn't been started)
     * - "dirty": most recent is a failure; no pending requests
     * - "inprogress": pending request
     */
    name = name || this._DEFAULT_NAME;
    if (this._isInProgress[name]) {
        return 'inprogress';
    } else {
        var deferreds = this._deferreds[name];
        if (deferreds && deferreds.length) {
            // look at last deferred. either it failed (dirty), it succeeded (clean)
            // or it hasn't been run yet (inprogress --> queue must be moving if it has elements)
            var lastDeferredState = deferreds[deferreds.length - 1].state();
            return lastDeferredState === 'rejected' ? 'dirty'
                : lastDeferredState === 'resolved' ? 'clean'
                : 'inprogress';
        } else {
            return 'clean';
        }
    }
};

el8.model.AjaxQueue.prototype.isQueueDirty = function(name) {
    if (this._finalized) { return false; } // a finalized queue should not be saved anymore
    return (this.getQueueState(name) === 'dirty');
};

el8.model.AjaxQueue.prototype.isFinalized = function() {
    return this._finalized;
};
